(function () {
  'use strict';
  function track() {
    var slug = location.pathname.replace(/^\/+|\/+$/g, '');
    if (!slug || slug.indexOf('/') !== -1) return;
    try {
      fetch('/a/profile/view', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'user_url=' + encodeURIComponent(slug),
        keepalive: true,
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track);
  } else {
    track();
  }
})();
